import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useState, useEffect, useMemo } from 'react';
import EditWorkerModal from './EditWorkerModal'
import AddWorkerModal from './AddWorkerModal';
import '../../Styles/DraggableWorkerGrid.css'
import '../../Styles/button.css'
import {createCompanyWithSlots} from '../../service/companyService'
import Slot from './Slot';



function DraggableWorker({ worker, moveWorker, isAdmin, onDelete, handleEditClick }) {
  const [, ref] = useDrag({
    type: 'worker',
    item: { id: worker.id },
    canDrag: isAdmin,
  });
  const [, drop] = useDrop({
    accept: 'worker',
    drop: (item) => isAdmin && moveWorker(item.id, worker.id)
  });

  const renderedWorker = useMemo(() => {
    return (
      <div ref={node => ref(drop(node))} className="card">
        <div className="card-body">
          <h5 className="card-title">{worker.workerName}</h5>
          <p className="card-text">Firma: {worker.companyName}</p>
          <ul>
            {worker.roles.map(role => <li key={role}>{role}</li>)}
          </ul>
          {isAdmin && (
            <div>
            <button onClick={() => onDelete(worker.id)} className="delete-btn">
              Slet
            </button>
            <button onClick={() => handleEditClick(worker)} className='edit-btn'>Rediger</button>
</div>)}

        </div>
      </div>
    );
  }, [worker, ref, drop]);

  return renderedWorker;
}


function DraggableWorkerGrid({ workers, onMoveWorker, onDelete, onEdit, onUpdateWorker, onAddWorker, onNameChange, onRolesChange, isAdmin, selectedCompany}) {
    const [isAdding, setIsAdding] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editingWorker, setEditingWorker] = useState(null);

    
  useEffect(() => {
    const initializeCompany = async () => {
        try {
            await createCompanyWithSlots(selectedCompany);
        } catch (error) {
            console.error("Error initializing company: ", error);
        }
    };

    initializeCompany();
}, [selectedCompany]);

    const handleEditClick = (worker) => {
      setEditingWorker(worker);
      setIsEditing(true);
    };
    
    const handleSave = (updatedWorker) => {
      onUpdateWorker(updatedWorker.id, updatedWorker)
      setIsEditing(false);
   };
     const handleAddWorkerClick = () => {
      setIsAdding(true);
    };
    const handleCloseModal = () => {
      setIsEditing(false);
      setIsAdding(false);
   };
   
    
    const handleAddWorkerLocal = async (newWorker) => {
      try {
        await onAddWorker(newWorker);
        setIsAdding(false);
      } catch (error) {
        console.error("Error adding worker: ", error);
        
      }
    };
    
    
  
   

    const moveWorker = (toSlot, workerId) => {
      const newWorkers = workers.map(worker => ({...worker}));
      const draggedWorkerIndex = newWorkers.findIndex(worker => worker.id === workerId);
      const targetWorkerIndex = newWorkers.findIndex(worker => worker.slot === toSlot);
      if (draggedWorkerIndex === -1) {
        console.error("Dragged worker not found");
        return;
      }
      if (typeof toSlot === 'string') { 
        console.error("Attempted to move to a string slot:", toSlot);
        return;
      }
      if (targetWorkerIndex === -1) {
        newWorkers[draggedWorkerIndex].slot = toSlot;
      } else {
        const draggedWorkerOriginalSlot = newWorkers[draggedWorkerIndex].slot;
        const targetWorkerOriginalSlot = newWorkers[targetWorkerIndex].slot;

        newWorkers[draggedWorkerIndex].slot = targetWorkerOriginalSlot;
        newWorkers[targetWorkerIndex].slot = draggedWorkerOriginalSlot;
      }
    
      onMoveWorker(newWorkers);
    };
    
    
    

const initialSlots = Array.from({ length: 21 }).map((_, index) => 
  workers.find(worker => worker.slot === index) || null
);

const handleDelete = (workerId) => {
  onDelete(workerId);
};

  
        return (
          <DndProvider backend={HTML5Backend}>
          {isAdmin && (<button className='generic-ea-btn' onClick={handleAddWorkerClick}>Tilføj medarbejder</button>)}
          {isAdding && (
            <AddWorkerModal 
              onAddWorker={handleAddWorkerLocal}
              show={isAdding} 
              onNameChange={onNameChange}
              onRolesChange={onRolesChange}
              selectedCompany={selectedCompany}
              onClose={handleCloseModal}
            />
          )}
          {isEditing && (
            <EditWorkerModal
                onEdit={onEdit}
                onSave={handleSave}
                show={isEditing}
                worker={editingWorker}
                onClose={handleCloseModal}
            />
          )}

          <div className="grid-container-worker">
  {Array.from({ length: 21 }).map((_, index) => {
    const workerInSlot = workers.find(worker => worker.slot === index);
    return (
      <Slot 
        key={index}
        index={index}
        worker={workerInSlot}
        onDropWorker={moveWorker}
        isAdmin={isAdmin}
        DraggableWorker={DraggableWorker}
        onDelete={handleDelete}
        onEdit={handleEditClick}
      />
    );
  })}
</div>

        </DndProvider>
        );
      
}

export default DraggableWorkerGrid;
